import React from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css"; 
import { Carousel } from 'react-responsive-carousel';

// --- TODOS TUS IMPORTS DE IMÁGENES (Mantener exactamente igual) ---
import navi1slider1 from "../assets/navi1slider1.webp"
import navi1slider2 from "../assets/navi1slider2.webp"
import navi1slider3 from "../assets/navi1slider3.webp"
import navi1slider4 from "../assets/navi1slider4.webp"
import navi1slider5 from "../assets/navi1slider5.webp"
import navi2slider1 from "../assets/navi2slider1.webp"
import navi2slider2 from "../assets/navi2slider2.webp"
import navi3slider1 from "../assets/navi3slider1.webp"
import navi3slider2 from "../assets/navi3slider2.webp"
import navi3slider3 from "../assets/navi3slider3.webp"
import navi4slider1 from "../assets/navi4slider1.webp"
import navi4slider2 from "../assets/navi4slider2.webp"
import navi4slider3 from "../assets/navi4slider3.webp"
import navi4slider4 from "../assets/navi4slider4.webp"
import navi4slider5 from "../assets/navi4slider5.webp"
import navi4slider6 from "../assets/navi4slider6.webp"
import navi4slider7 from "../assets/navi4slider7.webp"
import navi5slider1 from "../assets/navi5slider1.webp"
import navi5slider2 from "../assets/navi5slider2.webp"
import navi5slider3 from "../assets/navi5slider3.webp"
import navi5slider4 from "../assets/navi5slider4.webp"
import navi5slider5 from "../assets/navi5slider5.webp"
import navi5slider6 from "../assets/navi5slider6.webp"
import navi5slider7 from "../assets/navi5slider7.webp"
import navi6slider1 from "../assets/navi6slider1.webp"
import navi6slider2 from "../assets/navi6slider2.webp"
import navi6slider3 from "../assets/navi6slider3.webp"
import navi6slider4 from "../assets/navi6slider4.webp"
import navi7slider1 from "../assets/navi7slider1.webp"
import navi7slider2 from "../assets/navi7slider2.webp"
import navi7slider3 from "../assets/navi7slider3.webp"
import navi7slider4 from "../assets/navi7slider4.webp"
import navi7slider5 from "../assets/navi7slider5.webp"
import navi7slider6 from "../assets/navi7slider6.webp"
import navi7slider7 from "../assets/navi7slider7.webp"
import navi7slider8 from "../assets/navi7slider8.webp"
import navi7slider9 from "../assets/navi7slider9.webp"
import navi7slider10 from "../assets/navi7slider10.webp"
import navi7slider11 from "../assets/navi7slider11.webp"
import navi8slider1 from "../assets/navi8slider1.webp"
import navi8slider2 from "../assets/navi8slider2.webp"
import navi8slider3 from "../assets/navi8slider3.webp"
import navi8slider4 from "../assets/navi8slider4.webp"
import navi8slider5 from "../assets/navi8slider5.webp"
import navi8slider6 from "../assets/navi8slider6.webp"
import navi8slider7 from "../assets/navi8slider7.webp"
import navi8slider8 from "../assets/navi8slider8.webp"
import navi8slider9 from "../assets/navi8slider9.webp"
import navi8slider10 from "../assets/navi8slider10.webp"
import navi8slider11 from "../assets/navi8slider11.webp"
import navi8slider12 from "../assets/navi8slider12.webp"
import navi8slider13 from "../assets/navi8slider13.webp"
import navi8slider14 from "../assets/navi8slider14.webp"
import navi8slider15 from "../assets/navi8slider15.webp"
import navi8slider16 from "../assets/navi8slider16.webp"
import navi9slider1 from "../assets/navi9slider1.webp"
import navi9slider2 from "../assets/navi9slider2.webp"
import navi9slider3 from "../assets/navi9slider3.webp"
import navi9slider4 from "../assets/navi9slider4.webp"
import navi9slider5 from "../assets/navi9slider5.webp"
import navi9slider6 from "../assets/navi9slider6.webp"
import navi9slider7 from "../assets/navi9slider7.webp"
import navi9slider8 from "../assets/navi9slider8.webp"
import navi9slider9 from "../assets/navi9slider9.webp"
import navi9slider10 from "../assets/navi9slider10.webp"
import navi9slider11 from "../assets/navi9slider11.webp"
import navi9slider12 from "../assets/navi9slider12.webp"
import navi9slider13 from "../assets/navi9slider13.webp"
import navi9slider14 from "../assets/navi9slider14.webp"
import navi9slider15 from "../assets/navi9slider15.webp"
import navi9slider16 from "../assets/navi9slider16.webp"
import navi9slider17 from "../assets/navi9slider17.webp"
import navi9slider18 from "../assets/navi9slider18.webp"
import navi9slider19 from "../assets/navi9slider19.webp"
import navi10slider1 from "../assets/navi10slider1.webp"
import navi10slider2 from "../assets/navi10slider2.webp"
import navi10slider3 from "../assets/navi10slider3.webp"
import navi10slider4 from "../assets/navi10slider4.webp"

import Navbar from "./Navbar";
import Footer from "./Footer";
import ScrollToTop from './ScrollToTop';

// Componente de Tarjeta de Memoria Navideña
const CardNavidad = ({ anio, parrafo, imagenes }) => (
  <div className='w-full max-w-[1100px] mx-auto mb-20 px-4'>
    <div className='bg-white rounded-[2.5rem] shadow-2xl overflow-hidden border border-gray-100 flex flex-col md:flex-row'>
      
      {/* Lado Imagen con Etiqueta de Año */}
      <div className='md:w-1/2 relative'>
        <div className='absolute top-6 left-6 z-20 bg-blue-700 text-white font-black text-2xl px-6 py-2 rounded-2xl shadow-lg'>
          {anio}
        </div>
        <Carousel 
          showStatus={false} 
          showThumbs={false} 
          infiniteLoop={true} 
          autoPlay={true} 
          interval={4500}
          className='h-full'
        >
          {imagenes.map((img, index) => (
            <div key={index} className='h-[350px] md:h-[500px]'>
              <img src={img} alt={`Navidad ${anio}`} className='object-cover h-full w-full' />
            </div>
          ))}
        </Carousel>
      </div>

      {/* Lado Texto */}
      <div className='md:w-1/2 p-8 md:p-12 flex flex-col justify-center bg-slate-50'>
        <div className='flex items-center gap-2 mb-4'>
          <div className='w-8 h-1 bg-red-500 rounded-full'></div>
          <span className='text-red-500 font-bold tracking-widest text-xs uppercase'>Memorias Fundación</span>
        </div>
        <h3 className='text-3xl font-bold text-slate-800 mb-6 leading-tight'>
          Impacto Social <br /> <span className='text-blue-600'>Diciembre {anio}</span>
        </h3>
        <p className='text-slate-600 text-lg leading-relaxed text-justify'>
          {parrafo}
        </p>
        <div className='mt-8 pt-6 border-t border-slate-200 flex items-center justify-between'>
          <span className='text-slate-400 text-sm italic'>🎄 Compartiendo alegría</span>
          <div className='flex gap-1'>
            <div className='w-2 h-2 rounded-full bg-blue-200'></div>
            <div className='w-2 h-2 rounded-full bg-blue-400'></div>
            <div className='w-2 h-2 rounded-full bg-blue-600'></div>
          </div>
        </div>
      </div>

    </div>
  </div>
);

const Navidad = () => {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      
      <div className='bg-gray-50 pt-28 pb-12 overflow-hidden'>
        
        {/* Encabezado Estético */}
        <div className='max-w-[1240px] mx-auto text-center mb-20 px-4'>
          <h1 className="text-5xl md:text-7xl font-black text-slate-900 tracking-tighter uppercase mb-4">
            Nuestra <span className='text-blue-700'>Navidad</span>
          </h1>
          <div className='flex justify-center items-center gap-4'>
            <div className='h-[2px] w-12 bg-red-500'></div>
            <p className='text-slate-500 font-medium tracking-[0.2em] text-sm uppercase'>Historia de sonrisas</p>
            <div className='h-[2px] w-12 bg-red-500'></div>
          </div>
        </div>

        {/* Mapeo de Secciones */}
        <CardNavidad 
          anio="2025"
          parrafo="Los días 6 y 22 de diciembre, la Navidad llegó a los corazones de los niños en Magdalena y Atlántico. A través de la entrega de regalos, se tejieron lazos de alegría en Sitionuevo-Magdalena, Barrio La Sierrita Biblioteca el Oasis, Puerto Colombia, Tubara -Atlántico Corregimiento San Luis. Una jornada dedicada a celebrar la infancia y compartir la magia de la época."
          imagenes={[navi10slider1, navi10slider2, navi10slider3, navi10slider4]}
        />

        <CardNavidad 
          anio="2024"
          parrafo="Los dias 21, 22 y 23 de diciembre se cumplieron las jornadas navideñas del año 2024, con el apoyo de varios benefactores y amigos se logró dar alegría a más de 220 niños en el barrios 20 de Julio de Barranquilla y los municipios de Sitio Nuevo Magdalena, Tubará y corregimiento San Luis Tubara en el Departamento del Atlántico"
          imagenes={[navi9slider1, navi9slider2, navi9slider3, navi9slider4, navi9slider5, navi9slider6, navi9slider7, navi9slider8, navi9slider9, navi9slider10, navi9slider11, navi9slider12, navi9slider13, navi9slider14, navi9slider15, navi9slider16, navi9slider17, navi9slider18, navi9slider19]}
        />

        <CardNavidad 
          anio="2023"
          parrafo="Fueron mas de 412 regalos entregados en Barrio La Manga Barranquilla, Corral de San luis Tubara Atlantico, La Puente Magdalena, Sitionuevo Magdalena, Barrio Siete de Agosto Barranquilla, Pital de Megua Baranoa Atlantico ,Sabanalarga Atlántico."
          imagenes={[navi8slider1, navi8slider2, navi8slider3, navi8slider4, navi8slider5, navi8slider6, navi8slider7, navi8slider8, navi8slider9, navi8slider10, navi8slider11, navi8slider12, navi8slider13, navi8slider14, navi8slider15, navi8slider16]}
        />

        <CardNavidad 
          anio="2022"
          parrafo="Entrega de 417 regalos de navidad a niños del Barrio La Manga en Barranquilla, Sitio Nuevo y Nueva Venecia Departamento del Magdalena, Corral de San Luis Tubará y Repelón Departamento del Atlántico."
          imagenes={[navi1slider1, navi1slider2, navi1slider3, navi1slider4, navi1slider5]}
        />

        <CardNavidad 
          anio="2021"
          parrafo="Entrega de regalos navideños y actividades culturales con niños y familias de los sectores rurales de Sitionuevo, el Torno Departamento del Magdalena, en Tubara sector Mocana del Departamento del Atlántico y Barrio la Manga de Barranquilla."
          imagenes={[navi2slider1, navi2slider2]}
        />

        <CardNavidad 
          anio="2020"
          parrafo="Se entregaron mercados navideños y regalos a niñas y niños de los sectores rurales de Sitionuevo Magdalena, Tubará Atlántico y Barrio La Manga Barranquilla. Las entregas fueron de casa en casa guardando los protocolos de bioseguridad, incluye entrega de tapabocas a cada familia."
          imagenes={[navi3slider1, navi3slider2, navi3slider3]}
        />

        <CardNavidad 
          anio="2019"
          parrafo="Se realiza un compartir navideño con el apoyo de más de 20 voluntarios en zona rural de Sitio Nuevo, Magdalena y se hace entrega de más de 300 regalos a niños en condición de vulnerabilidad."
          imagenes={[navi4slider1, navi4slider2, navi4slider3, navi4slider4, navi4slider5, navi4slider6, navi4slider7]}
        />

        <CardNavidad 
          anio="2018"
          parrafo="Se realiza un compartir navideño con el apoyo de más de 10 voluntarios en zona rural de Sitio Nuevo, Magdalena y se hace entrega de más de 200 regalos a niños en condición de vulnerabilidad."
          imagenes={[navi5slider1, navi5slider2, navi5slider3, navi5slider4, navi5slider5, navi5slider6, navi5slider7]}
        />

        <CardNavidad 
          anio="2017"
          parrafo="Se realiza entrega de regalos navideños a mas de 30 niños pertenecientes a la comunidad del barrio La Manga ubicado en Barranquilla, Atlantico."
          imagenes={[navi6slider1, navi6slider2, navi6slider3, navi6slider4]}
        />

        <CardNavidad 
          anio="2016"
          parrafo="En la Institución Educativa Distrital N° 176 se hace entrega de regalos navideños a los niños pertenecientes a la comunidad del Corregimiento de Juan Mina, Atlántico. Asi mismo se realizan donaciones a más de 30 niños del Barrio La Manga."
          imagenes={[navi7slider1, navi7slider2, navi7slider3, navi7slider4, navi7slider5, navi7slider6, navi7slider7, navi7slider8, navi7slider9, navi7slider10, navi7slider11]}
        />

        <div className='py-12 text-center'>
          <p className='text-slate-400 font-medium italic'>Fundación Vida y Obra del Docente Javier Duque Duque</p>
        </div>

      </div>
      <Footer />
    </>
  );
};

export default Navidad;